import { ImageBox, Text, TextLink } from '../../ui-kit';
import { editCopyByReplaceWithMultipleComponent } from '../../utilities/copyFunctions';
import { LOYALTY_IMAGES } from '../assets/images';
import { LoyaltyJoinMessageContainer } from '../assets/styles';
import * as COPY from '../utilities/copy';

const LoyaltyJoinMessage = ({ loyaltyRedesign2025Active }) => {
  const signIn = () => {
    if (window.openSignIn) {
      window.openSignIn(true);
    }
  };

  const signUp = () => {
    if (window.openSignUp) {
      window.openSignUp(true);
    }
  };
  const objectForReplace = {
    '<SIGN_IN>': (
      <TextLink as="div" onClick={signIn} hoverColor={loyaltyRedesign2025Active && 'voyagersMoonlight'}>
        {COPY.JOIN_VOYAGERS_MESSAGE_SIGNIN}
      </TextLink>
    ),
    '<SIGN_UP>': (
      <TextLink as="div" onClick={signUp} hoverColor={loyaltyRedesign2025Active && 'voyagersMoonlight'}>
        {COPY.JOIN_VOYAGERS_MESSAGE_SIGNUP}
      </TextLink>
    )
  };
  return (
    <LoyaltyJoinMessageContainer loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
      <ImageBox
        src={loyaltyRedesign2025Active ? LOYALTY_IMAGES.ADVENTURE_BUCK_COIN_GREEN : LOYALTY_IMAGES.ADVENTURE_BUCK_COIN}
        alt="adventure buck"
        width="16px"
        height="16px"
      />
      <Text fontSize={1} fontWeight="medium">
        {editCopyByReplaceWithMultipleComponent(COPY.JOIN_VOYAGERS_MESSAGE, objectForReplace)}
      </Text>
    </LoyaltyJoinMessageContainer>
  );
};

export default LoyaltyJoinMessage;
